module.exports = __webpack_public_path__ + "img/simulator_iPhoneX.71479486.png";